import Vue from 'vue';
import FastClick from 'fastclick';
/* rem设配开始 */

/* rem设配结束 */
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import { NavBar } from 'components';
import EasyCallPlugin from 'plugins/EasyCallPlugin';
import WXRouterPlugin from 'plugins/WXRouterPlugin';
import router from './router';
import App from './App';
import Meta from 'vue-meta';
import { Dialog } from 'vant';
import './components/list/icon/iconfont';

import { registerAnalytics } from 'utils/analytics';

registerAnalytics();

Vue.use(Meta);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(LoadingPlugin);
Vue.use(EasyCallPlugin);
Vue.use(WXRouterPlugin);
Vue.use(Dialog);
Vue.component(NavBar.name, NavBar);

FastClick.attach(document.body);



G.entryUrl = location.href.split('#')[0];
console.log('G.entryUrl------> ', G.entryUrl);

const app = new Vue({
router,
render: (h) => h(App)
}).$mount('#app');
Vue.config.productionTip = false;



// WEBPACK FOOTER //
// ./src/main.js